
<sh-tabs class="tab-background" slot="tabs">

    <sh-tab-item label="User Activity" (click)="navigateToUser()" id="user-activity" [active]=config.userActivity class="child-tab"></sh-tab-item>

    <sh-tab-item label="Audit Trail" (click)="navigateToAudit()" id="audit" [active]=config.audit class="child-tab"></sh-tab-item>
    <sh-tab-item label="Manage Corporate Structure" (click)="navigateToManageFolderStructure()" id="manageFolderStructure" [active]=config.manageFolderStructure class="child-tab"></sh-tab-item>
    </sh-tabs>
    <ng-container *ngIf="audit">
        <app-audit #auditPage></app-audit>
    </ng-container>
    <ng-container *ngIf="userActivity">
        <app-user-activity #userActivityPage></app-user-activity>
    </ng-container>
    <ng-container *ngIf="manageFolderStructure">
        <app-manage-folder-structure #manageFolderStructurePage></app-manage-folder-structure>
    </ng-container>
   